import PropTypes from 'prop-types'
import React from 'react'

import styles from './Header.scss'

const Header = (props) => {
    const { title, eventName, date } = props
    return (
        <reactFragment>
            <h1 className={styles.title}>
                {title}
            </h1>
            <div className={styles.eventName}>
                {eventName}
                {': '}
                {date}
            </div>
        </reactFragment>
    )
}

Header.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/Header/Header.jsx